import React from 'react';

const MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

function AmazonSalesUploadPopup({
  showPopup,
  closePopup,
  periodMode,
  handlePeriodModeChange,
  uploadWeek,
  setUploadWeek,
  uploadMonth,
  setUploadMonth,
  uploadYear,
  setUploadYear,
  selectedFile,
  parsedData,
  uploadStatus,
  fileInputRef,
  handleFileUpload,
  handleUploadSubmit,
  marketplaceConfig,
}) {
  if (!showPopup) return null;

  const isWeekly = periodMode === 'weekly';

  const isSubmitDisabled =
    !selectedFile ||
    !uploadYear ||
    (isWeekly ? !uploadWeek : !uploadMonth) ||
    parsedData.length === 0 ||
    uploadStatus?.type === 'loading';

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h2>Upload Amazon Sales Data</h2>
          <button className="close-popup" onClick={closePopup}>✕</button>
        </div>

        <div className="upload-form">

          {/* ── Period type toggle ── */}
          <div className="form-group">
            <label>Period Type</label>
            <div className="etsy-mode-buttons">
              <button
                className={`etsy-mode-btn ${isWeekly ? 'active' : ''}`}
                onClick={() => handlePeriodModeChange('weekly')}
              >
                Weekly
              </button>
              <button
                className={`etsy-mode-btn ${!isWeekly ? 'active' : ''}`}
                onClick={() => handlePeriodModeChange('monthly')}
              >
                Monthly
              </button>
            </div>
          </div>

          {/* ── Period fields ── */}
          <div className="form-row">
            {isWeekly ? (
              <div className="form-group half-width">
                <label>Week Number *</label>
                <input
                  type="number"
                  min="1"
                  max="53"
                  value={uploadWeek}
                  onChange={(e) => setUploadWeek(e.target.value)}
                  placeholder="Week (1-53)"
                />
              </div>
            ) : (
              <div className="form-group half-width">
                <label>Month *</label>
                <select
                  value={uploadMonth}
                  onChange={(e) => setUploadMonth(e.target.value)}
                  style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px' }}
                >
                  <option value="">Select month</option>
                  {MONTHS.map((m, i) => (
                    <option key={i + 1} value={i + 1}>{m}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group half-width">
              <label>Year *</label>
              <input
                type="number"
                min="2020"
                max="2030"
                value={uploadYear}
                onChange={(e) => setUploadYear(e.target.value)}
                placeholder="Year"
              />
            </div>
          </div>

          {/* ── File picker ── */}
          <div className="form-group">
            <label>Select File *</label>
            <div className="file-upload">
              <input
                type="file"
                ref={fileInputRef}
                accept=".csv,.xlsx,.xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
              <button
                className="file-upload-btn"
                onClick={() => fileInputRef.current.click()}
              >
                {selectedFile ? selectedFile.name : 'Choose CSV or Excel file'}
              </button>
              {selectedFile && (
                <span className="file-size">
                  ({(selectedFile.size / 1024).toFixed(2)} KB)
                </span>
              )}
            </div>
            <p className="file-hint">File must contain ASIN and Units columns</p>
          </div>

          {/* ── Status ── */}
          {uploadStatus && (
            <div className={`upload-status ${uploadStatus.type}`}>
              {uploadStatus.type === 'loading' ? '⏳' :
               uploadStatus.type === 'success' ? '✅' : '❌'}
              {uploadStatus.message}
            </div>
          )}

          {/* ── Preview ── */}
          {parsedData.length > 0 && (
            <div className="data-preview">
              <h3>
                Data Preview ({parsedData.length} rows)
                {!isWeekly && uploadMonth && uploadYear && (
                  <span style={{ fontSize: '13px', fontWeight: 'normal', marginLeft: '10px', color: '#666' }}>
                    — {MONTHS[uploadMonth - 1]} {uploadYear}
                  </span>
                )}
                {isWeekly && uploadWeek && uploadYear && (
                  <span style={{ fontSize: '13px', fontWeight: 'normal', marginLeft: '10px', color: '#666' }}>
                    — Week {uploadWeek}, {uploadYear}
                  </span>
                )}
              </h3>
              <div className="preview-table-container">
                <table className="preview-table">
                  <thead>
                    <tr><th>#</th><th>ASIN</th><th>Units</th></tr>
                  </thead>
                  <tbody>
                    {parsedData.slice(0, 10).map((row) => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>{row.asin}</td>
                        <td>{row.units}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {parsedData.length > 10 && (
                  <p className="preview-more">... and {parsedData.length - 10} more rows</p>
                )}
              </div>
            </div>
          )}

          {/* ── Buttons ── */}
          <div className="popup-buttons">
            <button className="cancel-btn" onClick={closePopup}>Cancel</button>
            <button
              className="submit-btn"
              onClick={() => handleUploadSubmit(marketplaceConfig)}
              disabled={isSubmitDisabled}
            >
              {uploadStatus?.type === 'loading' ? 'Processing...' : 'Upload Data'}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AmazonSalesUploadPopup;